export class Files {
    id: string;
    fileName: string; 
    size: number;
    fileType: string;
    uploadedBy: string;
    dateUploaded: Date;

    constructor() {
        this.id = '';
        this.fileName = '';
        this.size = 0;
        this.fileType = '';
        this.uploadedBy = '';
        this.dateUploaded = null;
    }
}